import React from 'react';
import { DateTime } from 'luxon';
import { FiClock, FiMessageCircle } from 'react-icons/fi';
import useInstructorActiveAttendanceSessions from './useInstructorActiveAttendanceSessions';
import styles from './InstructorActiveAttendanceSessions.module.css';

function formatTimeRange(startTime, endTime) {
  const start = DateTime.fromISO(new Date(startTime).toISOString()).setZone('America/Chicago');
  const end = DateTime.fromISO(new Date(endTime).toISOString()).setZone('America/Chicago');
  if (!start.isValid || !end.isValid) return '';
  return `${start.toFormat('h:mm a')} - ${end.toFormat('h:mm a')} CT`;
}

// The Q&A panel it opens (via onOpenQna) is rendered by the parent as its own
// independent section, not nested in this card - see InstructorDashboard.jsx.
function InstructorActiveAttendanceSessions({ onOpenQna }) {
  const { sessions, loading, getVisibleSessions } = useInstructorActiveAttendanceSessions();

  if (loading && sessions.length === 0) return null;

  const visibleSessions = getVisibleSessions();
  if (visibleSessions.length === 0) return null;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <FiClock size={20} />
          My Live Sessions
          <span className={styles.count}>{visibleSessions.length} today</span>
        </h2>
      </div>

      <div className={styles.list}>
        {visibleSessions.map((session) => {
          const name = session.course_name || session.elective_name;
          const code = session.course_code || session.elective_code;

          return (
            <div className={styles.sessionRow} key={`${session.entity_type}-${session.session_id}`}>
              <div className={styles.sessionInfo}>
                <div className={styles.sessionTitle}>
                  {code ? `${code} · ` : ''}{name || session.title || 'Attendance Session'}
                  {session.isActive && <span className={styles.liveDot} aria-hidden="true" />}
                </div>
                <div className={styles.sessionMeta}>{formatTimeRange(session.start_time, session.end_time)}</div>
              </div>
              <button
                type="button"
                className={styles.qnaButton}
                onClick={() => onOpenQna?.(session)}
              >
                <FiMessageCircle size={16} />
                Session Q&amp;A
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default InstructorActiveAttendanceSessions;
